import { delay, http, HttpResponse } from 'msw'
import { IBuyInfo } from 'types'

export const handlers = [
  http.get(
    '*/:id',
    async () =>
      HttpResponse.json({
        recordId: '0.8b031502.1728069898.d79f514a-01',
        cardHolder: {
          cardAccount: 'pjvRH6dG4yOjXNcATGafQlvjeskzhOhWLS/iHHM/s4U=',
          cardIdProc: '1de132f9-ea26-4b20-90a7-b511d6f05f83',
          cardNumber: 'kB/JmAk4ftlbliBq/FL9v0unIRiA7FZnGzswYWYyvUU=',
        },
        merchant: {
          name: 'Drogaria Araujo',
          address: {
            line1: '171 vapo',
            city: 'Ribeirao das Neves',
            postalCode: '78701',
            countryCode: 'USA',
            countryName: 'United States',
            countrySubdivisionCode: 'TX',
          },
          // address: {},
          description: 'Drogaria Araujo',
          logos: [
            {
              height: 200,
              width: 200,
              url: 'https://media.licdn.com/dms/image/v2/C560BAQHaVYd13rRz3A/company-logo_100_100/company-logo_100_100/0/1638831590218/linkedin_logo?e=1743638400&v=beta&t=PpzLLb8UR5KaHsJCclVcQVtQKhHvcdgnem-bdhQwds8',
              type: 'INDUSTRY',
              altTextTag: 'Shoe Stores Logo',
            },
            {
              height: 400,
              width: 400,
              url: 'https://media.licdn.com/dms/image/v2/C560BAQHaVYd13rRz3A/company-logo_100_100/company-logo_100_100/0/1638831590218/linkedin_logo?e=1743638400&v=beta&t=PpzLLb8UR5KaHsJCclVcQVtQKhHvcdgnem-bdhQwds8',
              type: 'INDUSTRY',
              altTextTag: 'Shoe Stores Logo',
            },
          ],
          location: {
            latitude: '-19.927812',
            longitude: '-43.950838',
            type: 'ROOFTOP',
          },
          // location: null,
        },
        purchaseReceipt: {},
        // purchaseReceipt: {
        //   url: 'https://api.ethocaweb.com/ethoca/receipt/1733935655/94037092-fb1a-4703-bf5c-20500e817ae0/-NEZDSMQf-duq8LPJTT08A/D0zNKSHsD5O0ukz5DA4nVuOBWD27kqnnPAAeYbMgSq6q-0OEsPloCHBIXfKhFoqwYmBnvqEBSoT9QMpxz_jwiSuDlvkerKqwn2orUcCX-YOn6yWUwrlRkGhK0KG_n3uSXsfJG0va5fyfjuiBc8dbRnMI_1ESrV5yjN0HHECMErwPfNgHN9AkTv2wmstiFAAUG8V5yxUbU9zKJUupdqby1Rtyp2JMEcybEU3T3XoIfsTIG5kTxommsyzShE9kyi_W6pEJaEmQGXJfs5380HftV3OfnD4SCJI1lbgpqyD4IOP3gd3w6IDFqjbKX03FD6guTc-dXAfWxCkRIvK3ONPswRNvMaAgjrIKohdHUcvQH87Z0xhYDB1hBeiWe88RW4exLicY8OExiHEy_CLckNvVM4FntV9JJs9qGkz6e9K3MIPV85tse3rvgJunosibrPglJrLUSIV85gJbO6iuMjSfWjtzlooc5rhJnk6cY2-n9i9X2CduLU_hwnjSme7OyP1KbjgryJeeL7yUJ2rP3lU1t362AtGkvLQo083a1WhKQN8Y4L2khRN-WI3ZRul9G994XGquS_RAZtdPD3EOZKpAXpYXgrkwXeFAjdZjMWjmFOqzohyAl0ADnf2rq97jy6pZhc36jgmuE3riWRt490j2zbD4nu6ijx1g1AKVO9uopzgPW21BKLI778WLGyAzr4V0xiM99aLY_QMpVwxn-LQUDwrY6IHzrnUaJOOYg_98AN9MsHmTgumzSoK701ivq7tUG-3Wa9gziMK_u_6rnVz7v0YWzftqZZUrrRSc4vH06GaBJShKewlGFuW47T01G4-dsMfMqYCBIzv6Pyvg9WjxGj-SrwKzNOpGr6-teo65QmU?locale=pt-BR&access_token=eyJ4NXQjUzI1NiI6Im13YjM2MXlBZWdCb2d3dERPbEhrejA3QndqZldQRGgwUndnQjUwaFFIM28iLCJraWQiOiIyMDIwMDkyODEwMzQwMC1TQUFULVRva2VuLUVuZ2luZSIsImN0eSI6IkpXUyIsInR5cCI6IkpXVCIsImFsZyI6IlJTMjU2In0.eyJ1c2VyX2NvbnNlbnQiOiJmYWxzZSIsInN1YiI6Im5vdF9hdmFpbGFibGUiLCJzY3AiOiJjb20ubWFzdGVyY2FyZC5ldGhvY2EuY2xhcml0eS5yZWNlaXB0OnJlY2VpcHQtc2VydmljZTpyZWNlaXB0LXNlcnZpY2UiLCJncnAiOltdLCJpc3MiOiJNQVNURVJDQVJEX1NBUyIsInR5cCI6Im9hdXRoMl9hY2Nlc3NfdG9rZW4iLCJ0aWQiOiJub3RfYXZhaWxhYmxlIiwiYXVkIjoiRXRob2NhRW5yaWNoZWRUcmFuc2FjdGlvbnMiLCJuYmYiOjE3MzM5MzU2NDUsImdyYW50X3R5cGUiOiJjbGllbnRfY3JlZGVudGlhbHMiLCJleHAiOjE3MzM5MzY1NTUsImF1dGhUeXBlIjoiT0F1dGgyIiwib25lX3RpbWUiOiJmYWxzZSIsImlhdCI6MTczMzkzNTY1NSwianRpIjoiNDJhZDRkOTQ2OGI1NDA1YmU3YzQ2YWY1NjY2MzUzNzUiLCJjaWQiOiJ4dnBMRmtTN25wM09LV3NVTHNSTnBQcW5JQlZwNkZEVlZRLXJPcHdhZmVhYTJjZWQifQ.VeAObARF3IaAGRuHMnfAsIU3pAvCdCTQOL5vCJT-jJtNsKT7NBVGWosirO-3TRa4LdKwiPKIIywPwNSXOwYXPqPR0Xtv57MMW-b3qgLFCdBzsO0bPOgEr_Iv4bgi3geN4n4ppy2ANkGpELxnr76kpGmILXVWiX2XD9VGQajwzVpsbY6zCKwFmS1Eem5K-IrtEJMftMnIWI6h9Gk1-La5RGov6vf7rZYkhZF52UE-OUVhDlPrW71C2NS3e781aMlJ_yOGhEokLu1mA_8alRXVYVKSnekCxANxGuuJG4-XRU7K4-_BC8Iy2LN0mfmFjgma4mtOiqbf68-ZvVzhGXjkCg',
        //   // url: String(htmlResponseEthoca),
        //   contentType: 'RECEIPT',
        //   expiresOn: '2024-10-04T19:39:58+00:00',
        // },
        transactionAmount: {
          value: 'R$ 459,58',
          currencyCode: 'BLR',
        },
      } as IBuyInfo),
    // HttpResponse.json({ error: 'error' }, { status: 422 }),
  ),
  http.post('*/transactions/:id', async () => {
    await delay(500)
    return HttpResponse.json({})
  }),
]
